import { render, staticRenderFns } from "./turn-cases-manage.vue?vue&type=template&id=437f5bb8"
import script from "./turn-cases-manage.vue?vue&type=script&lang=ts"
export * from "./turn-cases-manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports